package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminUserAnalyticsResponse(
    @SerialName("total_users") val totalUsers: Int,
    @SerialName("new_users_today") val newUsersToday: Int,
    @SerialName("new_users_this_week") val newUsersThisWeek: Int,
    @SerialName("new_users_this_month") val newUsersThisMonth: Int,
    @SerialName("active_24h") val active24h: Int,
    @SerialName("active_7d") val active7d: Int,
    @SerialName("active_30d") val active30d: Int,
    @SerialName("users_by_locale") val usersByLocale: Map<String, Int>,
    @SerialName("users_by_country") val usersByCountry: Map<String, Int>,
    @SerialName("total_devices") val totalDevices: Int,
    @SerialName("active_devices") val activeDevices: Int,
    @SerialName("revoked_devices") val revokedDevices: Int,
    @SerialName("devices_by_platform") val devicesByPlatform: Map<String, Int>,
    @SerialName("top_favorited_teams") val topFavoritedTeams: List<AdminTopFavoritedEntity>,
    @SerialName("top_favorited_leagues") val topFavoritedLeagues: List<AdminTopFavoritedEntity>,
    @SerialName("top_favorited_players") val topFavoritedPlayers: List<AdminTopFavoritedEntity>,
    @SerialName("notification_delivery_rate") val notificationDeliveryRate: Double,
    @SerialName("notification_read_rate") val notificationReadRate: Double,
    @SerialName("total_predictions") val totalPredictions: Int,
    @SerialName("predictions_today") val predictionsToday: Int,
    @SerialName("predictions_this_week") val predictionsThisWeek: Int,
    @SerialName("daily_signups") val dailySignups: Map<String, Int> = emptyMap(),
    @SerialName("onboarding_completed_count") val onboardingCompletedCount: Int = 0,
    @SerialName("onboarding_completion_rate") val onboardingCompletionRate: Double = 0.0,
    @SerialName("users_by_login_type") val usersByLoginType: Map<String, Int> = emptyMap(),
    @SerialName("users_by_timezone") val usersByTimezone: Map<String, Int> = emptyMap(),
    @SerialName("dau_mau_ratio") val dauMauRatio: Double = 0.0,
    val dau: Int = 0,
    val mau: Int = 0,
    @SerialName("total_team_favorites") val totalTeamFavorites: Int = 0,
    @SerialName("total_league_favorites") val totalLeagueFavorites: Int = 0,
    @SerialName("total_player_favorites") val totalPlayerFavorites: Int = 0,
    @SerialName("avg_favorites_per_user") val avgFavoritesPerUser: Double = 0.0,
    @SerialName("favorites_distribution") val favoritesDistribution: Map<String, Int> = emptyMap(),
)

@Serializable
data class AdminTopFavoritedEntity(
    @SerialName("entity_id") val entityId: String,
    @SerialName("name_en") val nameEn: String,
    @SerialName("name_ar") val nameAr: String? = null,
    val count: Int,
    @SerialName("logo_url") val logoUrl: String? = null,
    val source: String? = null,
)
